import HeroImage from '../../../../../public/assets/our-story/amy-and-harper.png'
import { Text } from 'components/Text'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import { Stack } from '../../../../components/Stack'
import { HeroContent, HeroRoot, HeroTitle } from './Hero.styles'

export const Hero = () => {
  const { t } = useTranslation()

  return (
    <HeroRoot>
      <HeroContent>
        <Stack
          justifyContent="space-between"
          direction={{ '@initial': 'column', '@bp2': 'row' }}
          gap={{ '@initial': '6', '@bp2': '9' }}
          alignItems="center"
          css={{ width: '100%' }}
        >
          <Stack css={{ flex: 1 }} justifyContent="center">
            <Stack direction="column" gap="3" justifyContent="center" css={{ maxWidth: '668px' }}>
              <HeroTitle>{t('our-story:hero.title')}</HeroTitle>
              <Text align="center" weight="light">
                {t('our-story:hero.body')}
              </Text>
            </Stack>
          </Stack>
          <Stack justifyContent="center" css={{ flex: 1 }}>
            <Stack direction="column" gap="2" justifyContent="center">
              <Image src={HeroImage} alt={t('our-story:hero.image-caption')} />
              <Text align="center" color="tertiary-400" weight="medium">
                {t('our-story:hero.image-caption')}
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </HeroContent>
    </HeroRoot>
  )
}
